intra_module.factory('Activity', function($resource, api_url, modules_url) {
    const url    = `${api_url}/sessions/:session_id/:activity_type/:activity_id`;
    const m_url  = `${modules_url}/:session_id/activities/:activity_id`;
    const params = {
        session_id:    '@session_id',
        activity_type: '@activity_type',
        activity_id:   '@activity_id'
    };
    const actions = {
        update: {
            method: 'PUT'
        },

        getActivities: {
            method:  'GET',
            isArray: true,
            url:     `${modules_url}/:session_id/activities`
        },

        getActivity: {
            method:  'GET',
            url:     `${m_url}`
        },

        profs: {
            url:     `${modules_url}/:session_id/profs`,
            isArray: true,
            method:  'GET',
            params: { session_id: '@session_id' }
        },

        unsubscribe: {
            url:     `${url}/unsubscribe`,
            isArray: true,
            method:  'GET'
        },

        mygroup: {
            url:     `${url}/mygroup`,
            method:  'GET'
        },

        groups: {
            url:     `${url}/groups`,
            isArray: true,
            method:  'GET'
        },

        files: {
            url:     `${m_url}/files`,
            isArray: true,
            method:  'GET'
        },

        stageFile: {
            url:     `${m_url}/stage/:stage/files`,
            isArray: true,
            method:  'GET',
            params:  { stage: '@stage' }
        },

        download: {
            url:     `${m_url}/download/:filename`,
            method:  'GET',
            params:  { filename: '@filename' }
        },

        stages: {
            url:     `${m_url}/stages`,
            method:  'GET',
            isArray: true
        },

        askValidation: {
            url:    `${m_url}/group/:group_id/stages/:stage_name/request`,
            method: 'POST',
            params: {
                group_id:    '@group_id',
                stage_name:  '@stage_name'
            }
        },

        cancel: {
            url:    `${m_url}/group/:group_id/stages/:stage_name/request`,
            method: 'DELETE',
            params: {
                group_id:    '@group_id',
                stage_name:  '@stage_name'
            }
        },

        manualValidation: {
            url:    `${url}/manualValidation`,
            method: 'PUT'
        },

        saveGroup: {
            url:    `${url}/group`,
            method: 'POST'
        },

        deleteGroup: {
            url:    `${url}/group/:group_id`,
            method: 'DELETE'
        },

        addMemberGroup: {
            url:    `${url}/group/:group_id`,
            method: 'POST',
            params: { group_id: '@group_id' }
        },

        deleteMemberGroup: {
            url:    `${url}/group/:group_id/removeMember`,
            method: 'PUT',
            params: { group_id: '@group_id' }
        },

        validationGroup: {
            url:    `${url}/group/:group_id`,
            method: 'PUT',
            params: { group_id: '@group_id' }
        },

        getPossibleMetaAcls: {
            url:     `${modules_url}/:module_id/activities/:activity_id/conversations/circles`,
            method:  'GET',
            isArray: true,
            params: {
                module_id:   '@module_id',
                activity_id: '@activity_id'
            }
        }
    };

    return $resource(url, params, actions);
});
